import { createAction, props } from '@ngrx/store';

import { DeliveryAsset } from '../../models';

const actionKey = '[Delivery Assets]';

export const LoadAsset = createAction(
  `${actionKey} Load asset`,
  props<{
    payload: {
      deliveryId: string;
      category: string;
    };
  }>(),
);

export const LoadAssetFail = createAction(
  `${actionKey} Load asset fail`,
  props<{ payload: any }>(),
);

export const LoadMoreAsset = createAction(
  `${actionKey} Load more asset`,
  props<{
    payload: {
      deliveryKeyCode: string;
      category: string;
    };
  }>(),
);

export const LoadMoreAssetSuccess = createAction(
  `${actionKey} Load more asset success`,
  props<{
    payload: {
      assets: DeliveryAsset[];
    };
  }>(),
);

export const LoadMoreAssetFail = createAction(`${actionKey} Load more asset fail`);

export const SetAssetState = createAction(
  `${actionKey} Set State`,
  props<{
    deliveryKeyCode: string;
    payload: {
      assets: DeliveryAsset[];
      isPlayingAll: boolean;
      isDefaultView: boolean;
      isDownloadingAll: boolean;
      isInfoView: boolean;
    };
  }>(),
);

export const SetSelectedAsset = createAction(
  `${actionKey} Set Selected Asset`,
  props<{ payload: DeliveryAsset }>(),
);

export const ClearSelectedAsset = createAction(`${actionKey} Clear selected Asset`);

export const SetReadyForPlaying = createAction(
  `${actionKey} set ready for playing`,
  props<{ payload: boolean }>(),
);

export const TogglePlaying = createAction(
  `${actionKey} Toggle playing`,
  props<{ payload: { play: boolean; isPlayingAll?: boolean } }>(),
);

export const SetPlayingAll = createAction(
  `${actionKey} Set playing all`,
  props<{ payload: boolean }>(),
);

export const AllowDownload = createAction(
  `${actionKey} Allow download`,
  props<{ payload: string }>(),
);

export const AllowDownloadAll = createAction(`${actionKey} Allow download all`);

export const ToggleDownloading = createAction(
  `${actionKey} Toggle downloading`,
  props<{ payload: any }>(),
);

export const ToggleCdnDownloading = createAction(
  `${actionKey} Toggle cdn downloading`,
  props<{ payload: any }>(),
);

export const ToggleDownloadAll = createAction(
  `${actionKey} Toggle download all`,
  props<{ payload: any }>(),
);

export const ToggleDownloadAllFormats = createAction(
  `${actionKey} Toggle download all formats`,
  props<{ payload: any }>(),
);

export const CancelDownloadAll = createAction(
  `${actionKey} Cancel download all`,
  props<{ payload: any }>(),
);

export const DownloadingSuccess = createAction(
  `${actionKey} Downloading success`,
  props<{ payload: string }>(),
);

export const DownloadingAllSuccess = createAction(`${actionKey} Downloading all success`);

export const DownloadingFail = createAction(
  `${actionKey} Downloading fail`,
  props<{ payload: string }>(),
);

export const DownloadingAllFail = createAction(
  `${actionKey} Downloading all fail`,
  props<{ payload: string }>(),
);

export const CancelDownloading = createAction(
  `${actionKey} Cancel downloading`,
  props<{ payload: string }>(),
);

export const SetDefaultView = createAction(
  `${actionKey} Set Default View`,
  props<{ payload: { isDefaultView: boolean } }>(),
);

export const SetLoadingState = createAction(
  `${actionKey} Set Loading State`,
  props<{ payload: boolean }>(),
);

export const ToggleTabs = createAction(`${actionKey} Toggle tabs`, props<{ payload: boolean }>());

export const ResetPlay = createAction(
  `${actionKey} reset play`,
  props<{ payload: DeliveryAsset }>(),
);
